import { Field, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
@modelOptions({ schemaOptions: { timestamps: true } })
export class UserConversation extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  email: string

  @Field(() => String)
  @Prop({ type: String })
  externalUserId: string

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: true })
  isUnread: boolean

  @Field(() => String)
  @Prop({ type: String })
  subject: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  externalId: string

  @Field(() => String)
  @Prop({ type: String })
  conversationId: string

  @Field(() => String)
  @Prop({ type: String })
  content: string

  @Field(() => String)
  @Prop({ type: String })
  plainContent: string

  @Field(() => String)
  @Prop({ type: String })
  chatMessageId: string

  @Field(() => Boolean)
  @Prop({ type: Boolean })
  isPublic: boolean
}
